import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import React, { useState, useEffect, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import { UpdateIsCustomerReviewed, getNewCustomerData } from "../analyzeSlice";


export default function Table() {
    
  const autherization = localStorage.getItem("data");
  const data = JSON.parse(autherization);
  let setAccess = true;
  if (data?.restrictedAccess == 0) setAccess = true;
  else setAccess = false;

  const isRestrictedAccess = setAccess;
  console.log(isRestrictedAccess)
  const apiRef = useGridApiRef();
  const dispatch = useDispatch();
  const state = useSelector((store) => store.analyze);
  const {
    newCustomerDataPrepared,
    selectedCountry,
    selectedCountryID,
    duration,
  } = state;
  const { rows, columns } = newCustomerDataPrepared;
  const [tableRows, setTableRows] = useState(rows);
  const [rowSelectionModel, setRowSelectionModel] = React.useState([]);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 20,
    page: 0,
  });
  const [isReviewedSelected, setIsReviewedSelected] = useState("");
  const [searchText, setSearchText] = useState("");
  const selectWidth = "200";
  const selectHeight = "35";

  const handleUpdate = () => {
    const finalArray = rowSelectionModel.map((id) => {
      let updatedTrustValues = apiRef.current.getRowWithUpdatedValues(id);
      return updatedTrustValues;
    });

    const obj = {
      countryID: selectedCountryID,
      duration: duration,
    };

    console.log(finalArray);
    dispatch(UpdateIsCustomerReviewed(finalArray)).then(() => {
      dispatch(getNewCustomerData(obj));
    });

    setIsReviewedSelected("");
    setSearchText("");
    setPaginationModel({
      pageSize: 20,
      page: 0,
    })
  };
  // useEffect(() => {
  // 	setTableRows(rows);
  // }, [rows])

  const handleSearchText = (e) => {
    const value = e.target.value;
    setSearchText(value);

    // const searchLowercase = value.toLowerCase();
    // const filteredRows = rows?.filter((row) => {
    // 	return (
    // 		row.customerName.toLowerCase().includes(searchLowercase) ||
    // 		row.customerNumber.toLowerCase().includes(searchLowercase) ||
    // 		row.customerLocation.toLowerCase().includes(searchLowercase) ||
    // 		row.customerType.toLowerCase().includes(searchLowercase) ||
    // 		row.partnerType.toLowerCase().includes(searchLowercase)
    // 	);
    // });
    // setTableRows(filteredRows);
  };

  useEffect(() => {
    setTableRows(rows);
  }, [rows]);

  //   useEffect(() => {
  // 	if (searchText === '') {
  // 	  setTableRows(rows);
  // 	} else {
  // 	  const searchLowercase = searchText.toLowerCase();
  // 	  const filteredRows = rows.filter((row) => {
  // 		return (
  // 		  row.customerName.toLowerCase().includes(searchLowercase) ||
  // 		  row.customerNumber.toLowerCase().includes(searchLowercase) ||
  // 		  row.customerLocation.toLowerCase().includes(searchLowercase) ||
  // 		  row.customerType.toLowerCase().includes(searchLowercase) ||
  // 		  row.partnerType.toLowerCase().includes(searchLowercase)
  // 		);
  // 	  });
  // 	  setTableRows(filteredRows);
  // 	}
  //   }, [searchText, rows]);

  //   useEffect(() => {
  // 	if (isReviewedSelected === 'Reviewed' || isReviewedSelected === 'Not Reviewed') {
  // 	  const filteredRows = rows.filter((item) => {
  // 		return isReviewedSelected === 'Reviewed'
  // 		  ? item.isReviewed === 1
  // 		  : item.isReviewed === 0;
  // 	  });
  // 	  setTableRows(filteredRows);
  // 	} else {
  // 	  setTableRows(rows);
  // 	}
  //   }, [isReviewedSelected, rows]);

  useEffect(() => {
    let filteredRows = rows;

    if (
      isReviewedSelected === "Reviewed" ||
      isReviewedSelected === "Not Reviewed"
    ) {
      filteredRows = filteredRows.filter((item) => {
        return isReviewedSelected === "Reviewed"
          ? item.isReviewed === 1
          : item.isReviewed === 0;
      });
    }

    if (searchText !== "") {
      const searchLowercase = searchText.toLowerCase();
      filteredRows = filteredRows.filter((row) => {
        return (
          row.customerName.toLowerCase().includes(searchLowercase) ||
          row.customerNumber.toLowerCase().includes(searchLowercase) ||
          row.customerLocation.toLowerCase().includes(searchLowercase) ||
          row.customerType.toLowerCase().includes(searchLowercase) ||
          row.partnerType.toLowerCase().includes(searchLowercase)
        );
      });
    }

    setTableRows(filteredRows);
  }, [isReviewedSelected, searchText, rows]);

  console.log(rows);
  // useEffect(() => {
  // 	if (isReviewedSelected === "Reviewed" || isReviewedSelected === "Not Reviewed") {
  // 		setTableRows(prevVal => {
  // 			let val = rows?.filter(item => {
  // 				let retVal = false
  // 				if (isReviewedSelected === 'Reviewed') {
  // 					retVal = item.isReviewed === 1;
  // 				}
  // 				else if (isReviewedSelected === 'Not Reviewed') {
  // 					retVal = item.isReviewed === 0;
  // 				}
  // 				else {
  // 					return retVal
  // 				}
  // 				return retVal
  // 			})
  // 			return val
  // 		})
  // 	}
  // 	else {
  // 		setTableRows(rows)
  // 	}
  // }, [isReviewedSelected])

  // useEffect(() => {
  // 	if (searchText.length > 0) {
  // 		let val = rows?.filter(row => {
  // 			return (row.customerName.toLowerCase().includes(searchText.toLowerCase()) ||
  // 				row.customerNumber.toLowerCase().includes(searchText.toLowerCase()) ||
  // 				row.customerLocation.toLowerCase().includes(searchText.toLowerCase()) ||
  // 				row.customerType.toLowerCase().includes(searchText.toLowerCase()) ||
  // 				row.partnerType.toLowerCase().includes(searchText.toLowerCase()))
  // 		}
  // 		)
  // 		setTableRows(val)
  // 	}
  // 	else {
  // 		setTableRows(rows)
  // 	}
  // }, [searchText])

  return (
    <>
      <Box mb={3}>
        <Grid container columns={5} spacing={3}>
          <Grid item sm={1}>
            <FormControl>
              <InputLabel></InputLabel>
              <Select
                value={isReviewedSelected ? isReviewedSelected : "All"}
                label=""
                sx={{
                  height: selectHeight,
                  width: selectWidth,
                  color: "black.main",
                  mt: 1,
                }}
                onChange={(e) => setIsReviewedSelected(e.target.value)}
              >
                <MenuItem key={1} value={"All"}>
                  {"All"}
                </MenuItem>
                <MenuItem key={2} value={"Reviewed"}>
                  {"Reviewed"}
                </MenuItem>
                <MenuItem key={3} value={"Not Reviewed"}>
                  {"Not Reviewed"}
                </MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item sm={2}>
            <TextField
              variant="outlined"
              label="Filter.."
              value={searchText}
              onChange={handleSearchText}
              fullWidth
              size="small"
            ></TextField>
          </Grid>
        </Grid>
      </Box>
      <Box>
        <DataGrid
          apiRef={apiRef}
          rows={tableRows}
          columns={columns}
          getRowId={(row) => row?.customerID}
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
          pageSizeOptions={[20, 50, 100]}
          checkboxSelection={true}
          disableRowSelectionOnClick
          disableColumnMenu
          onRowSelectionModelChange={(newRowSelectionModel) => {
            console.log(newRowSelectionModel);
            setRowSelectionModel(newRowSelectionModel);
          }}
          sx={{ maxHeight: "74vh" }}
        />
      </Box>

      {rowSelectionModel.length > 0 ? (
        <Box mt={3} justifyContent="flex-end" display="flex">
          <Button
            //startIcon={<SearchIcon />}
            variant="contained"
            disabled={!isRestrictedAccess}
            onClick={handleUpdate}
            size="large"
            // className="mui_Button"
            //disabled={Object.keys(selectedPeriod).length === 0 || loadQuotaDetails ? true : false}
          >
            Save Changes
          </Button>
        </Box>
      ) : (
        <></>
      )}
    </>
  );
}
